import React, { useContext, useEffect, useState } from 'react'
import Globalcontext from '../../Context/Globalcontext';
import './Question.css'

const Question = (props) => {
  const [imgsr, setImgsr] = useState();
  const [selecta, setSelecta] = useState();
  const [selectb, setSelectb] = useState();
  const [selectc, setSelectc] = useState();
  const [selectd, setSelectd] = useState();

  const [correcta, setCorrecta] = useState("false");
  const [correctb, setCorrectb] = useState("false");
  const [correctc, setCorrectc] = useState("false");
  const [correctd, setCorrectd] = useState("false");


  const [background, setBackground] = useState();
  const a = useContext(Globalcontext);
  useEffect(() => {

    if (props.DataSource.sourcesr) {

      setImgsr(props.DataSource.sourcesr);
    }
    else {
      setImgsr(props.DataSource.sr);
    }

  })

  const setold = (q, correctoption, questionno) => {

    if (a.solutionflag == "false") {
      if (q !== undefined) {
        if (q == "OPTION A") {
          setdeselect();
          setSelecta("true");
          setquestionold(questionno, "OPTION A");

        }
        else if (q == "OPTION B") {
          setdeselect();
          setSelectb("true");
          setquestionold(questionno, "OPTION B");
        }
        else if (q == "OPTION C") {
          setdeselect();
          setSelectc("true");
          setquestionold(questionno, "OPTION C");
        }
        else if (q == "OPTION D") {
          setdeselect();
          setSelectd("true");
          setquestionold(questionno, "OPTION D");
        }

      }
    }
    else if (a.solutionflag == "true") {
      if (q !== undefined) {
        if (q == "OPTION A") {
          setdeselect();
          setSelecta("true");
          setquestionold(questionno, "OPTION A");

        }
        else if (q == "OPTION B") {
          setdeselect();
          setSelectb("true");
          setquestionold(questionno, "OPTION B");
        }
        else if (q == "OPTION C") {
          setdeselect();
          setSelectc("true");
          setquestionold(questionno, "OPTION C");
        }
        else if (q == "OPTION D") {
          setdeselect();
          setSelectd("true");
          setquestionold(questionno, "OPTION D");
        }
      }

      if (correctoption !== undefined) {
        if (correctoption == "OPTION A") {
          setCorrecta("false")
          setCorrectb("false")
          setCorrectc("false")
          setCorrectd("false")

          setCorrecta("true")

        }
        else if (correctoption == "OPTION B") {
          setCorrecta("false")
          setCorrectb("false")
          setCorrectc("false")
          setCorrectd("false")

          setCorrectb("true")
        }
        else if (correctoption == "OPTION C") {
          setCorrecta("false")
          setCorrectb("false")
          setCorrectc("false")
          setCorrectd("false")

          setCorrectc("true")
        }
        else if (correctoption == "OPTION D") {
          setCorrecta("false")
          setCorrectb("false")
          setCorrectc("false")
          setCorrectd("false")

          setCorrectd("true")
        }
      }
    }
  }

  const setquestionold = (questionno, option) => {

    if (questionno == "1") {
      a.setq1array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "2") {
      a.setq2array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "3") {
      a.setq3array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "4") {
      a.setq4array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "5") {
      a.setq5array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "6") {
      a.setq6array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "7") {
      a.setq7array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "8") {
      a.setq8array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "9") {
      a.setq9array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "10") {
      a.setq10array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "11") {
      a.setq11array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "12") {
      a.setq12array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "13") {
      a.setq13array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "14") {
      a.setq14array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "15") {
      a.setq15array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "16") {
      a.setq16array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "17") {
      a.setq17array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "18") {
      a.setq18array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "19") {
      a.setq19array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
    else if (questionno == "20") {
      a.setq20array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
    }
  }


  useEffect(() => {
    setdeselect();

    if (props.index + 1 == "1") {
      a.setq1array({ "qno": imgsr, "correct": props.DataSource.correct });

      if (a.q1) {
        setold(a.q1, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "2") {
      a.setq2array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q2) {
        setold(a.q2, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "3") {
      a.setq3array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q3) {
        setold(a.q3, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }

    }
    else if (props.index + 1 == "4") {
      a.setq4array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q4) {
        setold(a.q4, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "5") {
      a.setq5array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q5) {
        setold(a.q5, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "6") {
      a.setq6array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q6) {
        setold(a.q6, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "7") {
      a.setq7array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q7) {
        setold(a.q7, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "8") {
      a.setq8array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q8) {
        setold(a.q8, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "9") {
      a.setq9array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q9) {
        setold(a.q9, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "10") {
      a.setq10array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q10) {
        setold(a.q10, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "11") {
      a.setq11array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q11) {
        setold(a.q11, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "12") {
      a.setq12array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q12) {
        setold(a.q12, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "13") {
      a.setq13array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q13) {
        setold(a.q13, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "14") {
      a.setq14array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q14) {
        setold(a.q14, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "15") {
      a.setq15array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q15) {
        setold(a.q15, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "16") {
      a.setq16array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q16) {
        setold(a.q16, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "17") {
      a.setq17array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q17) {
        setold(a.q17, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "18") {
      a.setq18array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q18) {
        setold(a.q18, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "19") {
      a.setq19array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q19) {
        setold(a.q19, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }
    else if (props.index + 1 == "20") {
      a.setq20array({ "qno": imgsr, "correct": props.DataSource.correct });
      if (a.q20) {
        setold(a.q20, props.DataSource.correct, props.index + 1);
      }
      else {
        setold(props.DataSource.optiona, props.DataSource.correct, props.index + 1);
      }
    }


  }, [props.index])

  useEffect(() => {
    //  console.log(a.q1array);
  }, [a.q1array])

  const setselectcurrent = (event) => {
    if (a.solutionflag == "false") {
      const id = event.currentTarget.id;
      let op = "";
      if (id == 'o1') {
        setdeselect();
        setSelecta("true")
        op = "OPTION A";
      }
      else if (id == 'o2') {
        setdeselect();
        setSelectb("true")
        op = "OPTION B";
      }
      else if (id == 'o3') {
        setdeselect();
        setSelectc("true")
        op = "OPTION C";
      }
      else if (id == 'o4') {
        setdeselect();
        setSelectd("true")
        op = "OPTION D";
      }
      setanswer(props.index + 1, op);
    }
  }

  const setdeselect = () => {
    setSelecta("false")
    setSelectb("false")
    setSelectc("false")
    setSelectd("false")
  }

  // const updateState = (qsr, option) => {
    
  //   if (props.testname === "Main Test" || props.testname === "Demo Test") {
  //     const obj = a.mainresult[0];
      
  //     var data = [...a.mainresult];
  //     var index = data.findIndex(obj => obj.sr === qsr);
  //     data[index].optiona = option;
  //     a.setMainresult(data);
  //   }
  // }

  const updateState = (qsr, option) => {
    if (props.testname === "Main Test" || props.testname === "Demo Test") {
      const obj = a.mainresult[0];
      var data = [...a.mainresult];
    //  console.log(data);
      var index = data.findIndex(obj => obj.sr === qsr);
     // console.log("Qsr: ",qsr);
      if (index !== -1) {
        data[index].optiona = option;
        a.setMainresult(data);
      } else {
        console.error(`No object found with sr equal to ${qsr}`);
      }
    }
  };
  

  useEffect(() => {
    //console.log("whole object : ", a.mainresult);
  }, [a.mainresult])


  const setanswer = (questionnostring, option) => {
    // console.log( props.DataSource.sr)
    if (questionnostring == "1") {
      a.setq1array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq1(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "2") {
      a.setq2array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq2(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "3") {
      a.setq3array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq3(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "4") {
      a.setq4array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq4(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "5") {
      a.setq5array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq5(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "6") {
      a.setq6array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq6(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "7") {
      a.setq7array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq7(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "8") {
      a.setq8array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq8(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "9") {
      a.setq9array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq9(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "10") {
      a.setq10array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq10(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "11") {
      a.setq11array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq11(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "12") {
      a.setq12array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq12(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "13") {
      a.setq13array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq13(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "14") {
      a.setq14array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq14(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "15") {
      a.setq15array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq15(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "16") {
      a.setq16array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq16(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "17") {
      a.setq17array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq17(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "18") {
      a.setq18array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq18(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "19") {
      a.setq19array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq19(option);
      updateState(props.DataSource.sr, option);
    }
    else if (questionnostring == "20") {
      a.setq20array({ "qno": imgsr, "option": option, "correct": props.DataSource.correct });
      a.setq20(option);
      updateState(props.DataSource.sr, option);
    }
  }

  return (
    <>
      <div className='line2' />
      <div className="questionmain">
        <div className="inquestion">
          <div className='qhead'>
            <span style={{ fontWeight: "bolder" }}>Question No : {props.index + 1}</span>
            <span style={{marginLeft:"5px"}}> (Status- {a.calcstatus(props.index + 1)})</span>
          </div>
          <div className='line2' />
        </div>
        <div className="qarea">
          <span style={{ fontWeight: "bold" }}>{props.DataSource.chapter}</span>
          <span className='question'>{props.DataSource.chapterdescri}</span>
          <span className='questionlabel' >Question :</span>

          <div className='que'>
            <img className="imagereportq" src={`https://softtesting.in/iniqtest/cust/questionphoto/${imgsr}.svg`} alt="-" />
          </div>

          <span className='optionslabel'>Options :</span>
          {
            <div className='an'>
              <div onClick={setselectcurrent} id="o1" className={correcta == 'true' ? selecta == 'true' ? `ocorrect` : 'ocorrect' : selecta == 'true' ? `o` : ''}>
                <div className="anbox">
                  <span>1.</span>
                  <img className="imagereport" src={`https://softtesting.in/iniqtest/cust/optionaphoto/${imgsr}.svg`} alt="-" />
                </div>
              </div>
              <div onClick={setselectcurrent} style={background} id="o2" className={correctb == 'true' ? selectb == 'true' ? `ocorrect` : 'ocorrect' : selectb == 'true' ? `o` : ''}>
                <div className="anbox">
                  <span>2.</span>
                  <img className="imagereport" src={`https://softtesting.in/iniqtest/cust/optionbphoto/${imgsr}.svg`} alt="-" />
                </div>
              </div>
              <div onClick={setselectcurrent} style={background} id="o3" className={correctc == 'true' ? selectc == 'true' ? `ocorrect` : 'ocorrect' : selectc == 'true' ? `o` : ''}>
                <div className="anbox">
                  <span>3.</span>
                  <img className="imagereport" src={`https://softtesting.in/iniqtest/cust/optioncphoto/${imgsr}.svg`} alt="-" />
                </div>
              </div>
              <div onClick={setselectcurrent} style={background} id="o4" className={correctd == 'true' ? selectd == 'true' ? `ocorrect` : 'ocorrect' : selectd == 'true' ? `o` : ''}>
                <div className="anbox">
                  <span>4.</span>
                  <img className="imagereport" src={`https://softtesting.in/iniqtest/cust/optiondphoto/${imgsr}.svg`} alt="-" />
                </div>
              </div>
            </div>}

        </div>

      </div>
      <div className='line2' />

    </>
  )
}

export default Question
